// Leads load hone tak ka skeleton: asli PounceLeadCard jaisa hi dhaancha
// (banner, avatar + naam + status, contact, source/created, booking), taaki
// data aane par page uchhle nahi. Chamak shared <Shimmer /> se aati hai.
import React from "react";
import Shimmer from "../../Shimmer/Shimmer";
import styles from "./PounceLeadCardSkeleton.module.css";

const SkeletonCard = () => (
  <li className={styles.card}>
    <Shimmer height={48} radius={12} />

    <div className={styles.identity}>
      <Shimmer width={56} height={56} radius={14} />
      <div className={styles.nameBlock}>
        <Shimmer width="70%" height={22} radius={6} />
        <Shimmer width="50%" height={14} radius={4} />
      </div>
      <Shimmer width={84} height={28} radius={20} />
    </div>

    <Shimmer height={38} radius={10} />

    <div className={styles.meta}>
      <Shimmer width="40%" height={12} radius={4} />
      <Shimmer width="34%" height={12} radius={4} />
    </div>

    <Shimmer height={84} radius={16} />
  </li>
);

const PounceLeadCardSkeleton = ({ count = 3 }) => (
  <ul className={styles.list} aria-busy="true" aria-label="Loading leads">
    {Array.from({ length: count }, (_, i) => (
      <SkeletonCard key={i} />
    ))}
  </ul>
);

export default PounceLeadCardSkeleton;
